import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ModalDialog as ModalDialog$1 } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var _excluded = ["size"];
var BlockModalDialog = function BlockModalDialog(_ref) {
  var attrs = _ref.attrs,
    innerBlocks = _ref.innerBlocks,
    index = _ref.index,
    triggerProps = _ref.triggerProps;
  var _attrs$size = attrs.size,
    size = _attrs$size === void 0 ? 'md' : _attrs$size,
    rest = _objectWithoutProperties(attrs, _excluded);
  var body = /*#__PURE__*/React.createElement(React.Fragment, null, generateBlockList({
    blocks: innerBlocks
  }));
  return /*#__PURE__*/React.createElement(ModalDialog$1, _extends({
    key: index,
    size: size,
    renderBody: body
  }, rest, triggerProps));
};
BlockModalDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    size: PropTypes.string
  }),
  index: PropTypes.number,
  triggerProps: PropTypes.shape({}),
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var ModalDialog = BlockModalDialog;

export { ModalDialog as default };
